<div class="dx-card" id="accordion">
  <dx-accordion
    #accordion
    [dataSource]="[{ title: 'Job Specification', item: {} }]"
    [collapsible]="true"
    [animationDuration]="300"
    [focusStateEnabled]="false"
    [hoverStateEnabled]="false"
    [selectedIndex]="-1"
    (onSelectionChanged)="onAccordionClick($event)"
  >
    <div *dxTemplate="let itemData of 'title'">
      <h3>
        <span style="padding-left: 0.3em">{{ itemData.title }}</span>
      </h3>
    </div>
    <div *dxTemplate="let itemData of 'item'">
      <dx-form #jobForm labelMode="floating">
        <!-- Line 1 -->
        <dxi-item
          itemType="group"
          [colCount]="12"
          [colCountByScreen]="{ xs: 1 }"
          [cssClass]="'job-specification-group'"
        >
          <dxi-item name="products" [colSpan]="12">
            <div *dxTemplate="let data">
              <dx-select-box
                stylingMode="filled"
                label="Product *"
                [dataSource]="productFieldItems"
                displayExpr="displayValue"
                [searchEnabled]="false"
                style="caret-color: transparent"
                [(value)]="selectedProduct"
              ></dx-select-box>
            </div>
          </dxi-item>
        </dxi-item>

        <!-- Line 2 -->
        <dxi-item
          itemType="group"
          [colCount]="12"
          [colCountByScreen]="{ xs: 1 }"
          [cssClass]="'job-specification-group'"
        >
          <dxi-item name="width" [colSpan]="4">
            <div *dxTemplate="let data">
              <dx-text-box
                stylingMode="filled"
                [label]="
                  formatMessage('calculator.calculation.us.width') + ' *'
                "
                [(value)]="width"
              ></dx-text-box>
            </div>
          </dxi-item>
          <dxi-item name="height" [colSpan]="4">
            <div *dxTemplate="let data">
              <dx-text-box
                stylingMode="filled"
                [label]="
                  formatMessage('calculator.calculation.us.height') + ' *'
                "
                [(value)]="height"
              ></dx-text-box>
            </div>
          </dxi-item>
          <dxi-item name="pages" [colSpan]="4">
            <div *dxTemplate="let data">
              <dx-select-box
                stylingMode="filled"
                label="Pages *"
                [dataSource]="pageFieldItems"
                displayExpr="defaultValue"
                [searchEnabled]="false"
                style="caret-color: transparent"
                [(value)]="selectedPage"
              ></dx-select-box>
            </div>
          </dxi-item>
        </dxi-item>

        <!-- Line 3 -->
        <dxi-item
          itemType="group"
          [colCount]="12"
          [colCountByScreen]="{ xs: 1 }"
          [cssClass]="'job-specification-group'"
        >
          <dxi-item name="quantity1" [colSpan]="4">
            <div *dxTemplate="let data">
              <dx-text-box
                stylingMode="filled"
                label="Quantity 1 *"
                [(value)]="quantity1"
                maxLength="9"
              ></dx-text-box>
            </div>
          </dxi-item>
          <dxi-item name="quantity2" [colSpan]="4">
            <div *dxTemplate="let data">
              <dx-text-box
                stylingMode="filled"
                label="Quantity 2"
                [(value)]="quantity2"
                maxLength="9"
              ></dx-text-box>
            </div>
          </dxi-item>
          <dxi-item name="quantity3" [colSpan]="4">
            <div *dxTemplate="let data">
              <dx-text-box
                stylingMode="filled"
                label="Quantity 3"
                [(value)]="quantity3"
                maxLength="9"
              ></dx-text-box>
            </div>
          </dxi-item>
        </dxi-item>
        <!--          <dxi-item [colSpan]="12" [cssClass]="'quantity-text-item'">-->
        <!--            &lt;!&ndash; placeholder &ndash;&gt;-->
        <!--            <div class="quantity-text">-->
        <!--              <span>(Ordered quantity)</span>-->
        <!--            </div>-->
        <!--          </dxi-item>-->

        <!-- Line 4 -->
        <dxi-item
          itemType="group"
          [colCount]="12"
          [colCountByScreen]="{ xs: 1 }"
          [cssClass]="'job-specification-group'"
        >
          <dxi-item name="isReprint" [colSpan]="12">
            <div *dxTemplate="let data">
              <dx-radio-group
                [dataSource]="initialReprintFieldItems"
                [(value)]="initialReprint"
                displayExpr="displayValue"
                layout="horizontal"
                [disabled]="!_selectedProduct"
              >
              </dx-radio-group>
            </div>
          </dxi-item>
        </dxi-item>

        <!-- Line 5 -->
        <dxi-item
          itemType="group"
          [colCount]="12"
          [colCountByScreen]="{ xs: 1 }"
          [cssClass]="'job-specification-group'"
        >
          <dxi-item name="author" [colSpan]="6">
            <div *dxTemplate="let data">
              <dx-text-box
                stylingMode="filled"
                [label]="
                  formatMessage('calculator.calculation.us.author') || 'Author'
                "
                [(value)]="author"
              ></dx-text-box>
            </div>
          </dxi-item>

          <dxi-item name="title" [colSpan]="6">
            <div *dxTemplate="let data">
              <dx-text-box
                stylingMode="filled"
                [label]="formatMessage('calculator.calculation.us.title')"
                [(value)]="title"
              ></dx-text-box>
            </div>
          </dxi-item>
        </dxi-item>
        <!-- Line 6 -->
        <dxi-item
          itemType="group"
          [colCount]="12"
          [colCountByScreen]="{ xs: 1 }"
          [cssClass]="'job-specification-group'"
        >
          <dxi-item name="isbn" [colSpan]="12">
            <div *dxTemplate="let data">
              <dx-text-box
                stylingMode="filled"
                label="ISBN"
                [(value)]="isbn"
              ></dx-text-box>
            </div>
            <dxo-label text="ISBN"></dxo-label>
          </dxi-item>
        </dxi-item>
      </dx-form>
    </div>
  </dx-accordion>
</div>
